<script lang="ts">
import SectionPrelevMeans from '@/generated/sections/SectionPrelevMeans.vue';
import { storeSession } from '@/generated/stores';
import HubServices from '@/generated/hub/HubServices';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SectionPrelevMeans,
    created(): void {
        HubServices.connection.invoke('EnterRib', storeSession.httpToken);
        HubServices.connection.on('RibCreated', this.togglePaymentMeans);
        HubServices.connection.on('RibUpdated', this.togglePaymentMeans);
        HubServices.connection.on('RibDeleted', this.togglePaymentMeans);
    },
    beforeUnmount(): void {
        HubServices.connection.off('RibCreated', this.togglePaymentMeans);
        HubServices.connection.off('RibUpdated', this.togglePaymentMeans);
        HubServices.connection.off('RibDeleted', this.togglePaymentMeans);
    },
    methods: {
        togglePaymentMeans(): void {
            //this.togglePrelevRibId = !this.togglePrelevRibId;
        }
    }
})

</script>
